import Image from 'next/image';
import Link from 'next/link';
import { Dispatch, SetStateAction } from 'react';

type IHeaderLogoProps = {
  locale: string;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

export const HeaderLogo = ({ locale, setOpen }: IHeaderLogoProps) => {
  return (
    <Link
      href={`/${locale}`}
      className={'flex items-center'}
      onClick={() => {
        setOpen(false);
        window.dataLayer?.push({
          event: 'click_button',
          click_id: `/${locale}`,
          click_label: 'GoMoWorld',
        });
      }}
    >
      <Image
        src={'/static/images/logo-white.webp'}
        alt={'GoMoWorld Logo'}
        sizes={
          '(max-width: 640px) 100vw, (max-width: 768px) 80vw, (max-width: 1024px) 60vw, 50vw'
        }
        className={'object-cover'}
        width={168}
        height={32}
      />
    </Link>
  );
};
